/**
 * Wraps a promise and returns a tuple of [result, error].
 * Use instead of try/catch to keep code flatter and cleaner.
 */
export async function safeAsync<T>(promise: Promise<T>): Promise<[T | null, Error | null]> {
    try {
        const result = await promise
        return [result, null]
    } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error(String(err ?? 'Unknown error'))
        return [null, error]
    }
}
